export const fetchLogging = {
  'one-identity-authentication': true,
  'one-identity-authentication-legacy': true,
  'one-identity-authenticator-registration': true,
  'one-identity-change-password': true,
  'one-identity-create': true,
  'one-identity-credential-recovery': true,
  'one-identity-login': true,
  'one-identity-management-center': true,
  'one-identity-oauth': true,
  'one-identity-profile-builder': true,
  'one-identity-profile-sharer': true,
  'one-identity-root': true,
  'one-identity-third-party': true,
  'one-identity-two-step-manage': true,
  'one-identity-two-step-verification': true,
  'identity-ui-instant-profile': true,
  'identity-ui-profile-refresh': true,
  'identity-ui-two-step-manage': true,
  'identity-ui-two-step-verification': true,
  'identity-ui-management-center': true,

};

export const fetchLoggingProd = {
  'one-identity-authentication': true,
  'one-identity-authentication-legacy': true,
  'one-identity-authenticator-registration': true,
  'one-identity-change-password': true,
  'one-identity-create': true,
  'one-identity-credential-recovery': true,
  'one-identity-login': true,
  'one-identity-management-center': true,
  'one-identity-oauth': true,
  'one-identity-profile-builder': true,
  'one-identity-profile-sharer': true,
  'one-identity-root': true,
  'one-identity-third-party': true,
  'one-identity-two-step-manage': true,
  'one-identity-two-step-verification': true,
  'identity-ui-instant-profile': true,
  'identity-ui-profile-refresh': true,
  'identity-ui-two-step-manage': true,
  'identity-ui-two-step-verification': true,
  'identity-ui-management-center': true,
};

const targetAllowUrls = [
  'americanexpress.com',
  'aexp.com',
  'amextravel.com',
  'americanexpresscruise.com',
  'americanexpressfhr.com',
];

const targetAllowUrlsString = JSON.stringify(targetAllowUrls);
const targetAllowUrlsStringE0 = JSON.stringify([...targetAllowUrls, 'localhost:3000']);

export const supportedLocales = [
  'de-at',
  'de-ch',
  'de-de',
  'en-au',
  'en-ca',
  'en-gb',
  'en-hk',
  'en-in',
  'en-la',
  'en-nz',
  'en-sg',
  'en-th',
  'en-us',
  'en-xa',
  'en-xb',
  'es-ar',
  'es-es',
  'es-mx',
  'fi-fi',
  'fr-be',
  'fr-ca',
  'fr-ch',
  'fr-fr',
  'it-it',
  'ja-jp',
  'nb-no',
  'nl-be',
  'nl-nl',
  'sv-se',
  'th-th',
  'zh-hk',
  'zh-tw',
];

const showFdicListArray = ['en-us'];

export default {
  supportedLocales: {
    client: {
      e0: supportedLocales,
      e1: supportedLocales,
      e2: supportedLocales,
      e3: supportedLocales,
      e3sl: supportedLocales,
    },
    server: {
      e0: supportedLocales,
      e1: supportedLocales,
      e2: supportedLocales,
      e3: supportedLocales,
      e3sl: supportedLocales,
    },
  },
  targetAllowList: {
    client: {
      e0: targetAllowUrlsStringE0,
      e1: targetAllowUrlsString,
      e2: targetAllowUrlsString,
      e3: targetAllowUrlsString,
      e3sl: targetAllowUrlsString,
    },
    server: {
      e0: targetAllowUrlsStringE0,
      e1: targetAllowUrlsString,
      e2: targetAllowUrlsString,
      e3: targetAllowUrlsString,
      e3sl: targetAllowUrlsString,
    },
  },
  showFdicList: {
    client: {
      e0: showFdicListArray,
      e1: showFdicListArray,
      e2: showFdicListArray,
      e3: showFdicListArray,
      e3sl: showFdicListArray,
    },
    server: {
      e0: showFdicListArray,
      e1: showFdicListArray,
      e2: showFdicListArray,
      e3: showFdicListArray,
      e3sl: showFdicListArray,
    },
  },
  fetchLogging: {
    client: {
      e0: fetchLogging,
      e1: fetchLogging,
      e2: fetchLogging,
      e3: fetchLoggingProd,
      e3sl: fetchLoggingProd,
    },
    server: {
      e0: fetchLogging,
      e1: fetchLogging,
      e2: fetchLogging,
      e3: fetchLoggingProd,
      e3sl: fetchLoggingProd,
    },
  },
  faasApiUrl: {
    client: {
      e0: 'http://localhost:3002/faas',
      e1: 'https://functions-dev.americanexpress.com',
      e2: 'https://functions-qa.americanexpress.com',
      e3: 'https://functions.americanexpress.com',
      e3sl: 'https://functions-staging.americanexpress.com',
    },
    server: {
      e0: 'http://localhost:3002/faas',
      e1: 'https://functions-dev.aexp.com',
      e2: 'https://functions-qa.aexp.com',
      e3: 'https://functions.aexp.com',
      e3sl: 'https://functions-staging.americanexpress.com',
    },
  },
  dynatraceAppId: {
    client: {
      e0: 'N/A',
      e1: '2C9E1DC96044E26F',
      e2: '7A01FCE73A2B424A',
      e3: '805648A8067AAC83',
      e3sl: '00DEE39BD3758103',
    },
    server: {
      e0: 'N/A',
      e1: '2C9E1DC96044E26F',
      e2: '7A01FCE73A2B424A',
      e3: '805648A8067AAC83',
      e3sl: '00DEE39BD3758103',
    },
  },
  globalDashboardUrl: {
    client: {
      e0: 'http:localhost:3002/dashboard',
      e1: 'https://e1qglobal.americanexpress.com/dashboard',
      e2: 'https://e2qglobal.americanexpress.com/dashboard',
      e3: 'https://global.americanexpress.com/dashboard',
      e3sl: 'https://global.americanexpress.com/dashboard',
    },
    server: {
      e0: 'http:localhost:3002/dashboard',
      e1: 'https://e1qglobal.americanexpress.com/dashboard',
      e2: 'https://e2qglobal.americanexpress.com/dashboard',
      e3: 'https://global.americanexpress.com/dashboard',
      e3sl: 'https://global.americanexpress.com/dashboard',
    },
  },
  productDomain: {
    client: {
      e0: 'http:localhost:3002',
      e1: 'https://e1qglobal.americanexpress.com',
      e2: 'https://e2qglobal.americanexpress.com',
      e3: 'https://global.americanexpress.com',
      e3sl: 'https://global.americanexpress.com',
    },
    server: {
      e0: 'http:localhost:3002',
      e1: 'http://mycasvce1qglobal.webqa.ipc.us.aexp.com:5555',
      e2: 'http://mycaservicese2qglobal.webqa.ipc.us.aexp.com:5555',
      e3: 'http://mycaservicesglobal.web.ipc.us.aexp.com:5555',
      e3sl: 'http://mycaservicesglobal.web.ipc.us.aexp.com:5555',
    },
  },
  inauthScriptDomain: {
    client: {
      e1: 'https://staging.cdn-net.com',
      e2: 'https://staging.cdn-net.com',
      e3: 'https://www.cdn-path.com',
      e3sl: 'https://www.cdn-path.com',
    },
    server: {
      e1: 'https://staging.cdn-net.com',
      e2: 'https://staging.cdn-net.com',
      e3: 'https://www.cdn-path.com',
      e3sl: 'https://www.cdn-path.com',
    },
  },
  globalAccountManagementUrl: {
    client: {
      e1: 'https://e1qglobal.americanexpress.com/account-management',
      e2: 'https://e2qglobal.americanexpress.com/account-management',
      e3: 'https://global.americanexpress.com/account-management',
      e3sl: 'https://global.americanexpress.com/account-management',
    },
    server: {
      e1: 'https://e1qglobal.americanexpress.com/account-management',
      e2: 'https://e2qglobal.americanexpress.com/account-management',
      e3: 'https://global.americanexpress.com/account-management',
      e3sl: 'https://global.americanexpress.com/account-management',
    },
  },
  globalSecurityAndPrivacyUrl: {
    client: {
      e1: 'https://e1qglobal.americanexpress.com/account-management/security-and-privacy',
      e2: 'https://e2qglobal.americanexpress.com/account-management/security-and-privacy',
      e3: 'https://global.americanexpress.com/account-management/security-and-privacy',
      e3sl: 'https://global.americanexpress.com/account-management/security-and-privacy',
    },
    server: {
      e1: 'https://e1qglobal.americanexpress.com/account-management/security-and-privacy',
      e2: 'https://e2qglobal.americanexpress.com/account-management/security-and-privacy',
      e3: 'https://global.americanexpress.com/account-management/security-and-privacy',
      e3sl: 'https://global.americanexpress.com/account-management/security-and-privacy',
    },
  },
  oneDomain: {
    client: {
      e1: 'one-release-dev.americanexpress.com',
      e2: 'one-release-qa.americanexpress.com',
      e3: 'one-release.americanexpress.com',
      e3sl: 'one-release.americanexpress.com',
    },
    server: {
      e1: 'one-release-dev.americanexpress.com',
      e2: 'one-release-qa.americanexpress.com',
      e3: 'one-release.americanexpress.com',
      e3sl: 'one-release.americanexpress.com',
    },
  },
  oneUrl: {
    client: {
      e1: 'https://one-release-dev.americanexpress.com',
      e2: 'https://one-release-qa.americanexpress.com',
      e3: 'https://one-release.americanexpress.com',
      e3sl: 'https://one-release.americanexpress.com',
    },
    server: {
      e1: 'https://one-release-dev.americanexpress.com',
      e2: 'https://one-release-qa.americanexpress.com',
      e3: 'https://one-release.americanexpress.com',
      e3sl: 'https://one-release.americanexpress.com',
    },
  },
  onlineDomain: {
    client: {
      e1: 'e1qonline.americanexpress.com',
      e2: 'e2qonline.americanexpress.com',
      e3: 'online.americanexpress.com',
      e3sl: 'online.americanexpress.com',
    },
    server: {
      e1: 'e1qonline.americanexpress.com',
      e2: 'e2qonline.americanexpress.com',
      e3: 'online.americanexpress.com',
      e3sl: 'online.americanexpress.com',
    },
  },
  globalDomain: {
    client: {
      e1: 'e1qglobal.americanexpress.com',
      e2: 'e2qglobal.americanexpress.com',
      e3: 'global.americanexpress.com',
      e3sl: 'global.americanexpress.com',
    },
    server: {
      e1: 'e1qglobal.americanexpress.com',
      e2: 'e2qglobal.americanexpress.com',
      e3: 'global.americanexpress.com',
      e3sl: 'global.americanexpress.com',
    },
  },
  registerUrl: {
    client: {
      e1: 'https://www.americanexpress.com',
      e2: 'https://www.americanexpress.com',
      e3: 'https://www.americanexpress.com',
      e3sl: 'https://www.americanexpress.com',
    },
    server: {
      e1: 'https://www.americanexpress.com',
      e2: 'https://www.americanexpress.com',
      e3: 'https://www.americanexpress.com',
      e3sl: 'https://www.americanexpress.com',
    },
  },
  oauthAssetsUrl: {
    client: {
      e1: 'https://inter-pdgemapp.aexp.com/content/dam/one-amex/digitalidentity/oauth',
      e2: 'https://origin-pqgemapp.americanexpress.com/content/dam/one-amex/digitalidentity/oauth',
      e3: 'https://icm.aexp-static.com/content/dam/one-amex/digitalidentity/oauth',
      e3sl: 'https://icm.aexp-static.com/content/dam/one-amex/digitalidentity/oauth',
    },
    server: {
      e1: 'https://inter-pdgemapp.aexp.com/content/dam/one-amex/digitalidentity/oauth',
      e2: 'https://origin-pqgemapp.americanexpress.com/content/dam/one-amex/digitalidentity/oauth',
      e3: 'https://icm.aexp-static.com/content/dam/one-amex/digitalidentity/oauth',
      e3sl: 'https://icm.aexp-static.com/content/dam/one-amex/digitalidentity/oauth',
    },
  },
  safekeyMessageApiUrl: {
    client: {
      e1: 'https://safekey2-dev.americanexpress.com/GravityACS/webview',
      e2: 'https://acs.safekeyqa.americanexpress.com/GravityACS/webview',
      e3: 'https://acs-safekey.americanexpress.com/GravityACS/webview',
      e3sl: 'https://acs-safekey.americanexpress.com/GravityACS/webview',
    },
    server: {
      e1: 'https://safekey2-dev.americanexpress.com/GravityACS/webview',
      e2: 'https://acs.safekeyqa.americanexpress.com/GravityACS/webview',
      e3: 'https://acs-safekey.americanexpress.com/GravityACS/webview',
      e3sl: 'https://acs-safekey.americanexpress.com/GravityACS/webview',
    },
  },
  pushConfirmationApiUrl: {
    client: {
      e1: 'https://e1qonline.webqa.ipc.us.aexp.com/us/identity/cc/message',
      e2: 'https://e2sonline.americanexpress.com/us/identity/cc/message',
      e3: 'https://online.americanexpress.com/us/identity/cc/message',
      e3sl: 'https://online.americanexpress.com/us/identity/cc/message',
    },
    server: {
      e1: 'https://e1qonline.webqa.ipc.us.aexp.com/us/identity/cc/message',
      e2: 'https://e2sonline.americanexpress.com/us/identity/cc/message',
      e3: 'https://online.americanexpress.com/us/identity/cc/message',
      e3sl: 'https://online.americanexpress.com/us/identity/cc/message',
    },
  },
  oneSeoApiUrl: {
    client: {
      e0: 'http:localhost:3002/ReadWebpageMetaTags.v2',
      e1: 'https://functions-dev.americanexpress.com/ReadWebpageMetaTags.v2',
      e2: 'https://functions-qa.americanexpress.com/ReadWebpageMetaTags.v2',
      e3: 'https://functions.americanexpress.com/ReadWebpageMetaTags.v2',
      e3sl: 'https://functions.americanexpress.com/ReadWebpageMetaTags.v2',
    },
    server: {
      e0: 'http:localhost:3002/ReadWebpageMetaTags.v2',
      e1: 'https://functions-dev.aexp.com/ReadWebpageMetaTags.v2',
      e2: 'https://functions-qa.aexp.com/ReadWebpageMetaTags.v2',
      e3: 'https://functions.aexp.com/ReadWebpageMetaTags.v2',
      e3sl: 'https://functions.aexp.com/ReadWebpageMetaTags.v2',
    },
  },
  bdaasApiUrl: {
    client: {
      e1: 'https://bdaas-staging-dev.americanexpress.com/api',
      e2: 'https://bdaas-staging-qa.americanexpress.com/api',
      e3: 'https://bdaas.americanexpress.com/api',
      e3sl: 'https://bdaas.americanexpress.com/api',
    },
    server: {
      e1: 'https://bdaas-staging-dev.americanexpress.com/api',
      e2: 'https://bdaas-staging-qa.americanexpress.com/api',
      e3: 'https://bdaas.americanexpress.com/api',
      e3sl: 'https://bdaas.americanexpress.com/api',
    },
  },
  gemUrl: {
    client: {
      e1: 'https://inter-pdgemapp.aexp.com',
      e2: 'https://origin-pqgemapp.americanexpress.com',
      e3: 'https://icm.aexp-static.com',
      e3sl: 'https://icm.aexp-static.com',
    },
    server: {
      e1: 'https://inter-pdgemapp.aexp.com',
      e2: 'https://origin-pqgemapp.americanexpress.com',
      e3: 'https://icm.aexp-static.com',
      e3sl: 'https://icm.aexp-static.com',
    },
  },
  pznApiUrl: {
    client: {
      e0: 'http://localhost:3002/personalization',
      e1: 'https://pirecommendation-dev.americanexpress.com/amexsite/personalization',
      e2: 'https://pirecommendation-qa.americanexpress.com/amexsite/personalization',
      e3: 'https://pirecommendation.americanexpress.com/amexsite/personalization',
      e3sl: 'https://pirecommendation.americanexpress.com/amexsite/personalization',
    },
    server: {
      e0: 'http://localhost:3002/personalization',
      e1: 'https://qarecommendation-dev.aexp.com/amexsite/personalization',
      e2: 'https://qarecommendation-qa.aexp.com/amexsite/personalization',
      e3: 'https://sarecommendation.aexp.com/amexsite/personalization',
      e3sl: 'https://sarecommendation.aexp.com/amexsite/personalization',
    },
  },
  holocronModulesPath: {
    client: {
      e1: 'https://cdaas-dev.americanexpress.com/cdaas/axp-app/modules',
      e2: 'https://qwww.aexp-static.com/cdaas/axp-app/modules',
      e3: 'https://www.aexp-static.com/cdaas/axp-app/modules',
      e3sl: 'https://www.aexp-static.com/cdaas/axp-app/modules',
    },
    server: {
      e1: 'https://cdaas-dev.americanexpress.com/cdaas/axp-app/modules',
      e2: 'https://qwww.aexp-static.com/cdaas/axp-app/modules',
      e3: 'https://www.aexp-static.com/cdaas/axp-app/modules',
      e3sl: 'https://www.aexp-static.com/cdaas/axp-app/modules',
    },
  },
  recaptchaSiteKey: {
    client: {
      e1: '6LcrxsIlAAAAAP8csA1JyQ82DvFTt5l_lcVeWXl-',
      e2: '6LfURtEmAAAAAMo848NxYjTnXIREhYJtcA96TkSi',
      e3: '6LeGk8MmAAAAACKEcneoHIPx_FW9ZASsKL5zB9IT',
      e3sl: '6LeGk8MmAAAAACKEcneoHIPx_FW9ZASsKL5zB9IT',
    },
    server: {
      e1: '6LcrxsIlAAAAAP8csA1JyQ82DvFTt5l_lcVeWXl-',
      e2: '6LfURtEmAAAAAMo848NxYjTnXIREhYJtcA96TkSi',
      e3: '6LeGk8MmAAAAACKEcneoHIPx_FW9ZASsKL5zB9IT',
      e3sl: '6LeGk8MmAAAAACKEcneoHIPx_FW9ZASsKL5zB9IT',
    },
  },
};
